import React from 'react';
import { Loader2 } from 'lucide-react';
import type { NetworkingTaskRow, NetworkingTaskStatus } from '../../lib/networkingTasks';
import { ModalBody, ModalFooter, ModalHeader, ModalOverlay, ModalPanel } from '../Common/ModalShell';
import { taskStatusConfirmCopy } from './transcriptTaskStatusConfirm';

interface ConfirmTranscriptTaskStatusModalProps {
  task: NetworkingTaskRow | null;
  nextStatus: NetworkingTaskStatus | null;
  isOpen: boolean;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmTranscriptTaskStatusModal: React.FC<ConfirmTranscriptTaskStatusModalProps> = ({
  task,
  nextStatus,
  isOpen,
  busy = false,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen || !task || !nextStatus) return null;

  const copy = taskStatusConfirmCopy(nextStatus);

  return (
    <ModalOverlay onClose={busy ? undefined : onCancel} closeOnBackdropClick={!busy} zIndexClass="z-[60]">
      <ModalPanel maxWidthClass="max-w-md" titleId="confirm-task-status-title">
        <ModalHeader title={copy.title} onClose={busy ? undefined : onCancel} titleId="confirm-task-status-title" />
        <ModalBody>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{copy.body}</p>
          <p className="mt-3 text-sm font-medium text-gray-900 dark:text-white line-clamp-3">{task.title}</p>
        </ModalBody>
        <ModalFooter className="flex items-center justify-end gap-2">
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg disabled:opacity-50 ${copy.confirmClass}`}
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            {copy.confirmLabel}
          </button>
        </ModalFooter>
      </ModalPanel>
    </ModalOverlay>
  );
};

export default ConfirmTranscriptTaskStatusModal;
